import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicEntry from "@/pages/PublicEntry";
import Auth from "@/pages/Auth";
import AuthFinish from "@/pages/AuthFinish";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import ForecastPage from "@/pages/ForecastPage";
import ActualsPage from "@/pages/ActualsPage";
import GoalsPage from "@/pages/GoalsPage";
import Account from "@/pages/Account";
import AdminPage from "@/pages/AdminPage";
import AdminAiCostPage from "@/pages/AdminAiCostPage";
import AdminSetupVideosPage from "@/pages/AdminSetupVideosPage";
import AdminTicketsPage from "@/pages/AdminTicketsPage";
import AdminRoadmapPage from "@/pages/AdminRoadmapPage";
import AdminFaqsPage from "@/pages/AdminFaqsPage";
import AdminCampaignsPage from "@/pages/AdminCampaignsPage";
import CommunityPage from "@/pages/CommunityPage";
import AdminEventsPage from "@/pages/AdminEventsPage";
import HelpPage from "@/pages/HelpPage";
import RoadmapPage from "@/pages/RoadmapPage";
import Upgrade from "@/pages/Upgrade";
import ReferralsPage from "@/pages/ReferralsPage";
import AdminArticlesPage from "@/pages/AdminArticlesPage";
import AdminArticleEditor from "@/pages/AdminArticleEditor";
import ForgotPassword from "@/pages/ForgotPassword";
import LegalPage from "@/pages/LegalPage";
import AppShell from "@/components/AppShell";
// CookieBanner removed Iter38 — replaced by Cookiebot on forecastly.me (covers app.forecastly.me too)

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-heading text-2xl uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) {
    // Preserve where the visitor was trying to go (e.g. /actuals from an email
    // CTA) so Auth.jsx can land them there post-login.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?next=${next}`} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicEntry />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/finish" element={<AuthFinish />} />
            <Route path="/auth/forgot" element={<ForgotPassword />} />
            <Route path="/auth/reset" element={<ForgotPassword />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/cookies" element={<LegalPage kind="cookies" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route
              path="/onboarding"
              element={
                <Protected>
                  <Onboarding />
                </Protected>
              }
            />
            <Route
              element={
                <Protected>
                  <AppShell />
                </Protected>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/forecast" element={<ForecastPage />} />
              <Route path="/actuals" element={<ActualsPage />} />
              <Route path="/goals" element={<GoalsPage />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/ai-cost" element={<AdminAiCostPage />} />
              <Route path="/admin/setup-videos" element={<AdminSetupVideosPage />} />
              <Route path="/admin/tickets" element={<AdminTicketsPage />} />
              <Route path="/admin/roadmap" element={<AdminRoadmapPage />} />
              <Route path="/admin/faqs" element={<AdminFaqsPage />} />
              <Route path="/admin/campaigns" element={<AdminCampaignsPage />} />
              <Route path="/admin/events" element={<AdminEventsPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/roadmap" element={<RoadmapPage />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/refer" element={<ReferralsPage />} />
              <Route path="/admin/articles" element={<AdminArticlesPage />} />
              <Route path="/admin/articles/new" element={<AdminArticleEditor />} />
              <Route path="/admin/articles/:id" element={<AdminArticleEditor />} />
            </Route>
          </Routes>
          {/* CookieBanner removed Iter38 — Cookiebot on forecastly.me covers both domains via multi-domain config */}
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
